// extracted by css-extract-rspack-plugin
export default {"wrapper":"_b545797c","header":"_f169e5d0","viewMoreButtonWrapper":"_9ac469b2","viewMoreButton":"_bef3a6e1","hideItem":"_79b2dfa"};